export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7732.4bea1ebc.jpg";